import styled from '@emotion/styled';
import { palette, spacing, typography } from '../../../style-utils/theme';

/* The few pieces the resident's Lobbero IQ panel adds to the shared chat
   chrome (components/iq/iq-chat.styled). Everything else — the launcher, the
   panel, the bubbles, the composer — is the staff panel's own, so the two
   read as one product. */

/** The rows under an answer: one parcel, one visit, one pass. */
export const ItemList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
`;

export const Item = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  padding-top: ${spacing.xs};
  border-top: 1px solid ${palette.line};
`;

export const ItemTitle = styled.span`
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  font-weight: ${typography.weight.semibold};
  color: ${palette.ink};
  overflow-wrap: anywhere;
`;

export const ItemDetail = styled.span`
  font-family: ${typography.ui};
  font-size: ${typography.size.xs}px;
  color: ${palette.slateLight};
  overflow-wrap: anywhere;
`;

/** What the answer offers next: open the screen, or review the pass. */
export const AnswerActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.xs};
  padding-top: ${spacing.xs};
`;
